module.exports = __webpack_public_path__ + "static/img/200261.0b489ce0.png";